export const Header = () => <h1 className="bold m-0 text-2xl">Enforcement Actions</h1>;
